module.exports = __webpack_public_path__ + "img/restaurant-square-white.b29573b4.svg";